import React from "react";
import { Route, Switch } from "react-router-dom";

import CustomViews from "./customViews/index";
import SocialApps from "./socialApps/index";

import Users from './users/index';
import Material from './material/index';

const App = ({ match }) => {
  console.log("DESDE_ROTES_INDEX")
  console.log(match)
  console.log(match.url)
  console.log("DESDE_ROTES_INDEX")
  return (
    <div className="gx-main-content-wrapper">
      <Switch>
        <Route path={`${match.url}custom-views`} component={CustomViews} />
        <Route path={`${match.url}social-apps`} component={SocialApps} />

        <Route path={`${match.url}usuarios`} component={Users} />
        <Route path={`${match.url}material`} component={Material} />
      </Switch>
    </div>
  );
}

export default App;
